module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAQBJREFUOE9jZKASYKSSOQxDxKB5UZLuDIxMEli9/f/fi6Rlz3eiy2F4bV6MdDoDA9MM/GH3LyNpydOZyGowDJodLW3BzMi4mOE/IwtWwxj///n/529k8ornZ/AaRG4sYrhobqSUDQMT03pGRkYRbIb+////DTPDv4CEpc+O4nXR3FiZZMb/jHPwuew/4/+U5MVP5hL0GshV/5iZsIYR099/f5KXPztCMNZmRkqJsDIzlf//j91rjIz/3/z++68zffmzN3hdNCdKtoSJiaEbn9cYGf4XJC55MhGvQVNDRSU42dmbGXFE/3/G/3++//xZm7369QuCYUROEhgimZYcrwEAe01QE/DyJ4QAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SearchPage/list.png
// module id = qW6p
// module chunks = 1